import { withStyles } from "@material-ui/core";
import styles from "./styles";
import PopupFieldRenderer from "./common/PopupFieldRenderer";
import constants from "./constants";
const PickupDeliveryPopupRenderer = ({
  stopType,
  isReturn,
  stopName,
  arrivalTime,
  departureTime,
  stopTime,
  serviceWindow,
  statusLabel,
  statusValue,
  stopStatusClass,
  departureTimeLabel,
  arrivalTimeLabel,
  stopTimeLabel,
  statusCodes,
  classes,
}) => {
  return (
    <div className={classes.popupContainer}>
      <PopupFieldRenderer
        label={stopType}
        value={stopName}
        valueClassName={classes.headerRowValue}
        rowClassName={classes.headerRowContainer}
        labelClassName={
          isReturn
            ? `${classes.headerLabel} ${classes.violation}`
            : classes.headerLabel
        }
      />
      <div className={classes.multipleColumnRowContainer}>
        <PopupFieldRenderer
          label={arrivalTimeLabel ?? constants.POPUP_LABELS.ARRIVAL_TIME}
          value={arrivalTime}
        />
        <div className={classes.rowContainerRight}>
          <PopupFieldRenderer
            label={departureTimeLabel ?? constants.POPUP_LABELS.DEPARTURE_TIME}
            value={departureTime}
          />
        </div>
      </div>
      <div className={classes.multipleColumnRowContainer}>
        <PopupFieldRenderer
          label={stopTimeLabel ?? constants.POPUP_LABELS.STOP_TIME}
          value={stopTime}
        />
        <div className={classes.rowContainerRight}>
          <PopupFieldRenderer
            label={statusLabel}
            value={statusValue}
            valueClassName={`${classes[stopStatusClass]} ${classes.statusValue}`}
            statusCodeValue={statusCodes ?? null}
          />
        </div>
      </div>
      <div className={classes.multipleColumnRowContainer}>
        <PopupFieldRenderer
          label={constants.POPUP_LABELS.SERVICE_WINDOW}
          value={serviceWindow}
          valueClassName={classes.statusValue}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(PickupDeliveryPopupRenderer);
